import capitalizeFirstLetter from './capitalizeFirstLetter'

const removeSpaceToString = value => (
  capitalizeFirstLetter(value.replace(/\s/g, '').trim())
)

export default removeSpaceToString
